import { Select } from 'components/ui/base/select/Select';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
    width: 100%;
`;
